module.exports = __webpack_public_path__ + "img/godo_mobile_01.faa80b50.png";